// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Ac_B","large":"styles_large__UaXyd"};